export const SET_TASKS = "SET_TASKS";
export const SET_LAST_CLICKED_ELEMENT = "SET_LAST_CLICKED_ELEMENT";
export const CLEAR_STATE = "CLEAR_STATE";